export const provinces = [
  {
    id: '11',
    name: 'Aceh',
  },
  {
    id: '12',
    name: 'Sumatera Utara',
  },
  {
    id: '13',
    name: 'Sumatera Barat',
  },
  {
    id: '14',
    name: 'Riau',
  },
  {
    id: '15',
    name: 'Jambi',
  },
  {
    id: '16',
    name: 'Sumatera Selatan',
  },
  {
    id: '17',
    name: 'Bengkulu',
  },
  {
    id: '18',
    name: 'Lampung',
  },
  {
    id: '19',
    name: 'Kepulauan Bangka Belitung',
  },
  {
    id: '21',
    name: 'Kepulauan Riau',
  },
  {
    id: '31',
    name: 'DKI Jakarta',
  },
  {
    id: '32',
    name: 'Jawa Barat',
  },
  {
    id: '33',
    name: 'Jawa Tengah',
  },
  {
    id: '34',
    name: 'DI Yogyakarta',
  },
  {
    id: '35',
    name: 'Jawa Timur',
  },
  {
    id: '36',
    name: 'Banten',
  },
  {
    id: '51',
    name: 'Bali',
  },
  {
    id: '52',
    name: 'Nusa Tenggara Barat',
  },
  {
    id: '53',
    name: 'Nusa Tenggara Timur',
  },
  {
    id: '61',
    name: 'Kalimantan Barat',
  },
  {
    id: '62',
    name: 'Kalimantan Tengah',
  },
  {
    id: '63',
    name: 'Kalimantan Selatan',
  },
  {
    id: '64',
    name: 'Kalimantan Timur',
  },
  {
    id: '65',
    name: 'Kalimantan Utara',
  },
  {
    id: '71',
    name: 'Sulawesi Utara',
  },
  {
    id: '72',
    name: 'Sulawesi Tengah',
  },
  {
    id: '73',
    name: 'Sulawesi Selatan',
  },
  {
    id: '74',
    name: 'Sulawesi Tenggara',
  },
  {
    id: '75',
    name: 'Gorontalo',
  },
  {
    id: '76',
    name: 'Sulawesi Barat',
  },
  {
    id: '81',
    name: 'Maluku',
  },
  {
    id: '82',
    name: 'Maluku Utara',
  },
  {
    id: '91',
    name: 'Papua Barat',
  },
  {
    id: '94',
    name: 'Papua',
  },
]
